import React, { useState } from 'react';
import { StarIcon } from 'lucide-react';
import { HeroAvatars } from './HeroAvatars';
import { mainGuide } from '../data/resources';
import { siteConfig } from '../data/siteConfig';
type HeroProps = {
  draftPreview: boolean;
};
export function Hero({
  draftPreview
}: HeroProps) {
  const [videoFailed, setVideoFailed] = useState(false);
  const showVideo = Boolean(siteConfig.heroVideoUrl) && !videoFailed;
  const {
    trust,
    heroBadge
  } = siteConfig;
  const showTrust = trust.confirmed || draftPreview;
  const ratingLabel = trust.rating.toLocaleString('it-IT');
  return <section className="bg-cream px-5 sm:px-8 pt-8 pb-12 sm:pt-14 sm:pb-16 overflow-hidden" data-id="element-85" data-mp="sartioyigybf">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-86" data-mp="ncq1hej3xont">
        <p className="inline-flex items-center rounded-full border border-berry-deep/40 px-3 sm:px-4 py-1.5 text-xs font-semibold tracking-[0.04em] sm:tracking-[0.12em] whitespace-normal text-berry-deep" data-id="element-87" data-mp="3d1imxgffvoql">
          SCEGLI · MODELLA · PERSONALIZZA · CREA
        </p>

        <h1 className="mt-5 font-serif text-[2.15rem] leading-[1.1] sm:text-5xl lg:text-[3.6rem] font-semibold text-plum text-balance" data-id="element-88" data-mp="3j9ahvf8c4u67">
          Trasforma un semplice cordoncino in{' '}
          <span className="italic font-medium text-berry-deep" data-id="element-89" data-mp="399tex5kgwudx">creazioni fatte con amore</span>.
        </h1>

        <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-90" data-mp="3e7l5nw9dmagj">
          Scopri il tricotin e dai forma a nomi, piccoli regali e decorazioni personalizzate. Una guida pratica, una raccolta di cartamodelli e quattro bonus per iniziare e trovare nuove idee, anche se parti da zero.
        </p>

        {showTrust && <div className="mt-6 inline-flex max-w-full items-center gap-3 rounded-2xl sm:rounded-full border border-butter-deep/40 bg-cream px-4 py-2.5 shadow-soft text-left" data-id="element-91" data-mp="2viy25i6ult52">
            <HeroAvatars data-id="element-92" data-mp="2hl9sz7m58afu" />
            <span className="flex flex-col sm:flex-row sm:items-center gap-x-2 gap-y-0.5" data-id="element-93" data-mp="2lkqwhvi0exid">
              <span className="flex items-center gap-2" data-id="element-94" data-mp="s21h48i0i7ye">
                <span className="flex gap-0.5 text-butter-deep" role="img" aria-label={`Valutazione media ${ratingLabel} su 5`} data-id="element-95" data-mp="s3mcg0c5huxb">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={14} aria-hidden="true" className="fill-current" data-id="element-96" data-mp="icromrj9an9r" data-mpi={i} />)}
                </span>
                <span className="text-sm font-semibold text-ink whitespace-nowrap" data-id="element-97" data-mp="deyh9v67vn7w">
                  {ratingLabel} / 5
                </span>
              </span>
              <span className="text-sm text-ink/80" data-id="element-98" data-mp="162ued0zp7h57">
                <span aria-hidden="true" className="hidden sm:inline" data-id="element-99" data-mp="15zzr71pavi83">· </span>
                {trust.customerLabel}
              </span>
            </span>
          </div>}

        <div className="relative mt-9 w-full max-w-[340px] sm:max-w-[400px]" data-id="element-100" data-mp="x0l8iofdkby5">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] border-[6px] border-white bg-blush shadow-frame ring-1 ring-berry/30" data-id="element-101" data-mp="3lu07neppzt62">
            {showVideo ? <video src={siteConfig.heroVideoUrl} poster={mainGuide.image} autoPlay muted loop playsInline controls={false} disablePictureInPicture preload="auto" onError={() => setVideoFailed(true)} aria-label="Video di presentazione di creazioni in tricotin" className="h-full w-full object-cover object-center" data-id="element-102" data-mp="1x9kwssxc7gkd" /> : <img src={mainGuide.image} alt={mainGuide.imageAlt} decoding="async" className="h-full w-full object-cover" data-id="element-103" data-mp="2b1966og7bqxn" />}
          </div>
          <span className="pointer-events-none absolute -top-3 right-3 flex h-[84px] w-[84px] flex-col items-center justify-center rounded-full bg-berry-deep px-1.5 text-center text-white shadow-soft ring-4 ring-cream" data-id="element-104" data-mp="2fz0znmwhvl3y">
            <span className="font-serif text-[15px] font-bold leading-none whitespace-nowrap" data-id="element-105" data-mp="2oye8qegpi7o5">{heroBadge.value}</span>
            <span className="mt-1 text-[10px] font-semibold leading-none whitespace-nowrap" data-id="element-106" data-mp="umhc873eqbm8">{heroBadge.label}</span>
          </span>
        </div>

        <a href="#acquista" className="mt-9 inline-flex min-h-[52px] w-full sm:w-auto items-center justify-center whitespace-normal rounded-full bg-berry-deep px-4 sm:px-9 py-4 text-base font-semibold text-white shadow-soft transition-colors duration-200 hover:bg-berry-darker" data-id="element-107" data-mp="zmlthzc53adi">
          Scopri il pack — {siteConfig.price}
        </a>
        <p className="mt-3.5 text-sm text-ink/70" data-id="element-108" data-mp="e7h93eirhopa">
          Pagamento unico · Prodotto digitale · Materiali non inclusi
        </p>
      </div>
    </section>;
}